<template>
<div class="rater-wrapper">
  <div class="detail-header" v-if="!settingData.review.not_list">
    <van-icon name="arrow-left" @click="backToList()" />
    <span>详情</span>
    <i class="icon-share" style="opacity: 0"></i>
  </div>
  <div class="rater-info">
    <div class="rater-avatar-pannel">
      <div class="avatar">
        <img :src="raterInfo.avatar" alt="">
      </div>
      <div class="name-and-group">
        <span class="n">{{raterInfo.rater}}</span>
        <span class="g">{{raterInfo.group}} {{raterInfo.duty}}</span>
      </div>
    </div>
    <div class="rater-stat-pannel">
      <div class="number">
        <span>编号</span>
        <span v-show="raterInfo.id">{{raterInfo.sort+1 | filterId}}</span>
      </div>
      <div class="Received">
        <span>活动评价</span>
        <span>{{submit_total}}</span>
      </div>
    </div>
    <div class="rater-duty-pannel">
      <div class="t">职责:</div>
      <div class="content">{{raterInfo.desc}}</div>
    </div>
<!--    <div class="rater-duty-pannel">-->
<!--      <div class="t">座右铭:</div>-->
<!--      <div class="content">{{raterInfo.motto}}</div>-->
<!--    </div>-->
  </div>

  <div class="questions-list">
    <div class="main-title">评价</div>
    <ul>
      <li v-for="(item,index) in questionDataAll" :key="item.id">
        <t-radio :question="item" :number="index+1" v-if="item.type === 3"></t-radio>
        <t-text-area :question="item" :number="index+1" v-if="item.type === 2"></t-text-area>
        <t-score-xin :question="item" :number="index+1" v-if="item.type === 11"></t-score-xin>
        <t-score-radio :question="item" :number="index+1" v-if="item.type === 10"></t-score-radio>
      </li>
    </ul>
    <div class="submit-btn" @click="submit()">完成</div>
  </div>


  <!--成功提示-->
  <div class="success-dialog" v-if="isSuccess">
    <div class="icon-success"></div>
    <div class="t-success">提交成功</div>
    <div class="d-success">评议信息提交成功,感谢您的反馈</div>
    <div class="back" @click="backToList()" v-if="!settingData.review.not_list">完成</div>
  </div>

  <!--登录-->
  <reviewLogin ref="reviewLogin"></reviewLogin>

</div>
</template>

<script>
import { Dialog } from 'vant';
import {getReviewRaterDetail, formSubmit, getWechatOpenid, formSetting} from "../../api/Interface";
import wxconfig from '../../utile/wxconfig'
import TRadio from "../../components/topicType/tRadio";
import TTextArea from "../../components/topicType/tTextArea";
import TScoreXin from "../../components/topicType/tScoreXin";
import TScoreRadio from "../../components/topicType/tScoreRadio";
import reviewLogin from  "./review-login"
export default {
  name: "rater",
  mixins:[wxconfig],
  components:{
    TRadio,
    TTextArea,
    TScoreXin,
    TScoreRadio,
    [Dialog.Component.name]: Dialog.Component,
    reviewLogin
  },
  data(){
    return{
      browser: {
        versions: (function () {
          var u = navigator.userAgent,
              app = navigator.appVersion;
          return {
            trident: u.indexOf("Trident") > -1 /*IE内核*/,
            presto: u.indexOf("Presto") > -1 /*opera内核*/,
            webKit: u.indexOf("AppleWebKit") > -1 /*苹果、谷歌内核*/,
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1 /*火狐内核*/,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) /*是否为移动终端*/,
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) /*ios终端*/,
            android: u.indexOf("Android") > -1 ||
                u.indexOf("Linux") > -1 /*android终端或者uc浏览器*/,
            iPhone: u.indexOf("iPhone") > -1 /*是否为iPhone或者QQHD浏览器*/,
            iPad: u.indexOf("iPad") > -1 /*是否iPad*/,
            webApp: u.indexOf("Safari") == -1 /*是否web应该程序，没有头部与底部*/,
            souyue: u.indexOf("souyue") > -1,
            superapp: u.indexOf("superapp") > -1,
            weixin: u.toLowerCase().indexOf("micromessenger") > -1,
            Safari: u.indexOf("Safari") > -1
          };
        })(),
      },
      is_start:false,
      raterInfo:{},
      settingData:{
        review:{
          not_list:true
        }
      },
      questionDataAll:[],
      questionCurrent:{},
      currentIndex:0,
      isSuccess:false,
      index:1,
      submit_total:0
    }
  },
  mounted(){
    this.getSettingData();
    this.index = this.$route.query.index*1;
  },
  filters:{
    filterId(val){
      return val>99?val:(val>9?`0${val}`:`00${val}`);
    }
  },
  watch: {
    currentIndex: {
      handler(newVal, odlVal) {
        this.questionCurrent = this.questionDataAll[newVal]
      },
      deep: true
    },
  },
  methods:{
    checkLogin(){
      if(this.$route.query.openid){
        this.$store.commit('saveOpenid',this.$route.query.openid)
        this.$store.commit('updateReviewLogin',true)
        if(this.$route.query.headimgurl){
          this.$store.commit('saveHeaderImg',this.$route.query.headimgurl)
        }else{
          this.$store.commit('saveHeaderImg','')
        }
        if(!this.$store.state.isReload){
          this.$store.commit('isReload',true);
          window.location.reload()
        }
        if(this.$route.query.id && this.$route.query.rater_id){
          this.getData();
        }
      }else{
        if(!this.$store.state.isReviewLogin || this.$store.state.openid ==''){
          if(this.$store.state.settingData.base.review_wechat_login){
            if(this.browser.versions.weixin){
              let params = {
                form_id:this.$route.query.id,
                redirect_url:location.href
              }
              getWechatOpenid(params).then(res=>{
                if(res.state){
                  location.href = res.data;
                }
              })
            }else{
              Dialog.alert({
                message: '请于微信中打开本页面',
              }).then(() => {
                // on close
              });
            }
          }else{
            this.getData();
            this.$refs.reviewLogin.open();
          }
        }else{
          this.getData();
        }
      }
    },
    getSettingData(){
      formSetting(this.$route.query.id).then(res=>{
        if(res.state){
          this.$store.commit('settingData',res.data);
          if(res.data.review.not_share){
            this.hideShareMenu();
          }
          this.checkLogin();
        }
      })
    },
    getData(){
      getReviewRaterDetail({form_id:this.$route.query.id,rater_id:this.$route.query.rater_id,openid:this.$store.state.openid}).then(res=>{
        if(res.state){
          this.settingData = res.data.setting;
          this.raterInfo = res.data.rater;
          this.questionDataAll = res.data.rater.questions;
          this.submit_total = res.data.submit_total;
          this.is_start = res.is_start;
          if(!this.is_start){
            Dialog.alert({
              message: '活动不在开始时间内',
            }).then(() => {
              // on close
            });
          }
          // setTimeout(()=>{
          //   this.wxready({
          //     title:res.data.title,
          //     desc:'欢迎使用云表单~',
          //     link:`${location.origin}/h5/rater?id=${this.$route.query.id}&rater_id=${this.$route.query.rater_id}`
          //   })
          // },1000)
          this.getwxconfig(()=>{
            this.wxready({
              title:res.data.title,
              desc:'欢迎使用云表单~',
              link:`${location.origin}/h5/rater?id=${this.$route.query.id}&rater_id=${this.$route.query.rater_id}`
            })
          })
        }else{
          if(res.error == 'notlogin'){
            this.$store.commit('saveOpenid','');
            this.$store.commit('updateReviewLogin',false);
            location.reload();
          }else{
            this.$Message.error(res.error);
          }
        }
      })
    },
    submit(){
      if(!this.is_start){
        Dialog.alert({
          message: '活动不在开始时间内',
        }).then(() => {
          // on close
        });
        return;
      }
      Dialog.confirm({
        message: '是否确认提交？',
        confirmButtonColor:'#0A4BCC'
      }).then(() => {
        let data = {
          form_id: this.$route.query.id,
          user_answers: this.$store.state.user_answers,
          rater_id:this.$route.query.rater_id,
          openid:this.$store.state.openid,
        }
        if(this.$store.state.headimgurl){
          data.headimgurl = this.$store.state.headimgurl
        }
        let requireArr = []
        console.log(this.questionDataAll)

        this.questionDataAll.forEach((item,i)=>{
          if(item.verify_rule.is_require){
            console.log(this.$store.state.user_answers[item.id])
            if(this.$store.state.user_answers[item.id]==='' || this.$store.state.user_answers[item.id]=== undefined ){
              requireArr.push(item.title)
            }
          }
        })
        if(requireArr.length>0){
          let errorStr = requireArr.join(',');
          this.$Message.error(errorStr+'为必填项!')
          return;
        }
        formSubmit(data).then(res => {
          let that = this
          if (res.state) {
            this.isSuccess = true;
            this.$store.commit('user_answers',{});
          } else {
            this.$Message.error(res.error);
          }
        }).catch(error => {
          console.log(error);
        })
      }).catch(() => {
            // on cancel
      });
    },
    backToList(){
      this.$router.push({name:'review',query:{id:this.$route.query.id}})
    }
  }
}
</script>

<style lang="scss">
.item-box{
  margin-bottom: 20px;
}
.question-item-title {
  font-size: 16px;
  color: #000;
  display: flex;
  align-items: flex-end;
  line-height: 30px;
  margin-bottom: 10px;
  .q-title {
    p {
      display: contents;
    }
  }

  .ivu-icon {
    color: #FF6600;
    font-size: 20px;
    margin-left: 15px;
    padding-bottom: 3px;
  }
}
.q-content {
  .scoerBoxIndex0 {
    display: flex;
    align-items: center;
    .ivu-radio-group{
      margin-left: 3px;
    }
  }
}


.rater-wrapper{
  padding:0 16px 40px;
  height: 100vh;
  background:url('../../assets/images/review/detail_bg.png') repeat-y top/100%;
  overflow: auto;
  .detail-header{
    margin-top: 20px;
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color:#ffffff;
    font-weight: 500;
    font-size:18px;
    .van-icon-arrow-left{
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size:22px;
    }
    .icon-share{
      display: block;
      width: 18px;
      height: 18px;
      background:url('../../assets/images/review/icon_share.png') no-repeat center/100%;
    }
  }
  .rater-info{
    margin-top: 30px;
    .rater-avatar-pannel{
      display: flex;
      .avatar{
        width: 64px;
        height: 80px;
        position: relative;
        img{
          position: absolute;
          top:0;
          left:0;
          width: 64px;
          height: 80px;
        }
      }
      .name-and-group{
        margin-left: 19px;
        flex:1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color:#ffffff;
        .n{
          font-size:18px;
          font-weight: 600;
        }
        .g{
          font-size:14px;
          display: -webkit-box;
          overflow: hidden;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;
        }
      }
    }
    .rater-stat-pannel{
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      div{
        padding:0 16px;
        width: 168px;
        height: 60px;
        background: rgba(255,255,255,0.1);
        border-radius: 12px;
        border: 1px solid #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color:#ffffff;
        font-size:15px;
        span{
          font-weight: 500;
          &:last-child{
            font-weight: 600;
            font-size:24px;
          }
        }
      }
    }
    .rater-duty-pannel{
      margin-top: 20px;
      color:#ffffff;
      .t{
        font-size: 18px;
        line-height: 25px;
        font-weight: 500;
      }
      .content{
        margin-top: 10px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
      }
    }
  }
  .questions-list{
    padding-bottom: 20px;
    margin-top: 40px;
    width: 100%;
    background: #ffffff;
    border-radius: 12px;
    position:relative;
    display: flex;
    flex-direction: column;
    align-items:center;
    .main-title{
      position:absolute;
      top:-17px;
      left:50%;
      transform:translateX(-50%);
      width: 122px;
      height: 34px;
      line-height: 34px;
      text-align:center;
      font-size:18px;
      font-weight: 500;
      color: #FFFFFF;
      background: #2F64F8;
      border-radius: 20px;
      border: 1px solid #FFFFFF;
    }
    ul{
      width: 100%;
      padding:20px 16px;
      display: flex;
      flex-direction: column;
    }
    .scoerBoxIndex3{
      display: flex;
      align-items: center;
      ul{
        padding:0;
        margin:0 0.2rem;
        flex-direction: row;
        flex:1;
      }
    }
    .submit-btn{
      width: 311px;
      height: 48px;
      line-height: 48px;
      text-align:center;
      background: linear-gradient(90deg, #8481F2 0%, #2360F9 100%);
      border-radius: 25px;
      font-weight: 600;
      color: #FFFFFF;
      font-size: 18px;
    }
  }

  .success-dialog{
    position:fixed;
    top:0;
    left:0;
    width:100vw;
    height: 100vh;
    overflow: hidden;
    z-index:9999;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon-success{
      width: 149px;
      height: 149px;
      background:url('../../assets/images/review/icon_success.png') no-repeat center/100%;
    }
    .t-success{
      margin-top: 30px;
      font-size: 21px;
      font-weight: 600;
      color: #222222;
      line-height: 30px;
    }
    .d-success{
      margin-top: 15px;
      font-size: 18px;
      font-weight: 400;
      color: #222222;
    }
    .back{
      margin-top: 35px;
      width: 343px;
      height: 48px;
      line-height: 48px;
      color:#FFFFFF;
      text-align: center;
      background: linear-gradient(90deg, #8481F2 0%, #2360F9 100%);
      border-radius: 25px;
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>